import { createApp } from 'vue';
import AlertModal from '../components/alert.vue';

export default {
    install(app) {
        app.config.globalProperties.$alert = (text, header = '알림') => {
            return new Promise((resolve) => {
                const container = document.createElement('div');
                document.body.appendChild(container);

                const modalApp = createApp(AlertModal, {
                    text,
                    header,
                    resolve,
                });

                modalApp.mount(container);
            });
        };
    },
};
